import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import { MOBILE_ESSENTIAL_SUBTITLES } from "components/allInOneDashboard/constants/mobileTheme";
import ProductCardIcon from "components/allInOneDashboard/ProductCardIcon";

/**
 * Compact square product card for mobile essentials carousel (Figma 176×176).
 */
const MobileEssentialCard = ({ product, onClick }) => {
  const title = product.name?.replace(/^Jarvis\s+/i, "") || product.name;
  const shortSubtitle =
    MOBILE_ESSENTIAL_SUBTITLES[product.id] ||
    MOBILE_ESSENTIAL_SUBTITLES[product.code?.toLowerCase?.()] ||
    null;
  const subtitle =
    shortSubtitle ||
    (product.isLocked
      ? product.lockedSubtitle || product.subtitle
      : product.subtitle);

  return (
    <Box
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      sx={{
        position: "relative",
        width: 176,
        height: 176,
        flexShrink: 0,
        borderRadius: "24px",
        border: "1px solid #E5E7EB",
        bgcolor: "#fff",
        overflow: "hidden",
        cursor: "pointer",
        boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
        scrollSnapAlign: "start",
      }}
    >
      {product.gradient ? (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background: product.gradient,
            filter: "blur(12px)",
            pointerEvents: "none",
          }}
        />
      ) : null}

      <Stack
        sx={{
          position: "relative",
          zIndex: 1,
          p: "21px",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <Text
          sx={{
            fontWeight: 700,
            fontSize: 20,
            color: "#111827",
            lineHeight: "28px",
            pr: 1,
          }}
        >
          {title}
        </Text>
        <Text
          sx={{
            mt: 0.5,
            fontWeight: 400,
            fontSize: 13,
            color: "#374151",
            lineHeight: 1.35,
            maxWidth: 120,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {subtitle}
        </Text>

        <ProductCardIcon
          product={product}
          sx={{
            position: "absolute",
            right: -8,
            bottom: -8,
            width: 110,
            height: 110,
            objectFit: "contain",
            pointerEvents: "none",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            left: 21,
            bottom: 21,
            width: 54,
            height: 54,
            borderRadius: "999px",
            border: "1px solid #F1F1F1",
            bgcolor: "rgba(255,255,255,0.6)",
            backdropFilter: "blur(11px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <ArrowForwardIcon sx={{ fontSize: 24, color: "#111827" }} />
        </Box>
      </Stack>
    </Box>
  );
};

export default MobileEssentialCard;
